import Vue from 'vue'
import VueRouter from 'vue-router'
import DataTable from '../page/DataTable.vue'
import DataScreen from '../page/DataScreen.vue'
import DataCharts from '../page/DataCharts.vue'
import DataAudit from '../page/DataAudit.vue'
import DataImport from '../page/DataImport.vue'
import MyTableNew from "@/page/MyTableNew.vue";

Vue.use(VueRouter)

export default new VueRouter({
  routes:[
    {
      path: '/data-table',
      name: 'DataTable',
      component: MyTableNew,
      props:true
    },
    {
      path: '/data-screen',
      name: 'DataScreen',
      component: DataScreen
    },
    {
      path: '/data-charts',
      name: 'DataCharts',
      component: DataCharts
    },
    {
      path: '/data-audit',
      name: 'DataAudit',
      component: DataAudit
    },
    {
      path: '/data-import',
      name: 'DataImport',
      component: DataImport
    }

  ]
})
